import { RoutePath, type RoutePaths } from "@/lib/routes"
import { DASHBOARD_ROOT_URL } from "../constants/dashboardRootUrl"
import { type PotRouteNames } from "./potRouteNames"

const potRootPath = RoutePath.create(
    `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/cagnotte` as const
)

/**
 * `headless` is preserved across the whole /cagnotte flow so mobile webviews keep
 * their chrome-less layout — see `getLayoutQueryParams`.
 */
export const potRoutesPaths = {
    pot: RoutePath.create(
        `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/cagnotte?headless=:headless` as const
    ),
    potUsage: potRootPath.create("/utilisation?headless=:headless"),
    potSpending: potRootPath.create("/montant?headless=:headless"),
    potReview: potRootPath.create("/resume?headless=:headless"),
} as const satisfies RoutePaths<PotRouteNames>
